import { useRive } from "@rive-app/react-canvas";
import vinAnim from "../../../assets/krishna-ai/vinanimation.riv";
import styles from '../styles/vinanimation.module.css';
const VinAnimation = ({ className }) => {
  const { RiveComponent } = useRive({
    src: vinAnim,
    animations: ["Breathe", "Blink"],
    autoplay: true,
  });

  return (
    <RiveComponent
      className={className ? className : styles.vinRive}
      fit="contain"
    />

  );
};

export default VinAnimation;
